let Modal = "web"
export default Modal;


